// Definition ID: def:rosta:ledger:paymentprovider:registry
// Central registry so the active payment provider can be swapped without touching
// host UI. Today: StreetWallet. Tomorrow: add another provider + flip `activeProvider`.

import { createStreetWalletProvider, type StreetWalletConfig } from './streetWallet';
import type { PaymentProvider } from './types';

export type PaymentProviderId = 'streetwallet';

const streetWalletConfig: StreetWalletConfig = {
  // Override baseUrl / allowedOrigin here per environment when needed.
};

const providers: Record<PaymentProviderId, PaymentProvider> = {
  streetwallet: createStreetWalletProvider(streetWalletConfig),
};

/** Currently selected provider. Swap this to change the payment method app-wide. */
export const activeProviderId: PaymentProviderId = 'streetwallet';

export function getPaymentProvider(): PaymentProvider {
  return providers[activeProviderId];
}

export function getPaymentProviderById(id: PaymentProviderId): PaymentProvider {
  return providers[id];
}
